module.exports = (__webpack_require__(/*! dll-reference dll_0d54bcfb85c434ac5a77 */ "dll-reference dll_0d54bcfb85c434ac5a77"))("./node_modules/react/index.js");